import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'product_feedbacks';

export const PRODUCT_FEEDBACK_ENDPOINTS = {
  createProductFeedback: formatEndpoint('', namespace),
};
